export class Nilve
{
      ms_zehut: number;
      ms_zehut_mazmin: number;
      id_nofesh: number;
      tr_leida: Date;
      shem_prati:string;
      shem_mishpacha:string;
      ms_darkon: string;
      tr_tokef_darkon:Date;
      shem_prati_loazi: string;
      shem_mishpacha_loazi:string;
      phone: string;
      gender:number;
      email:string;
      llo_nitsul_zakaut: number;
}